var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.prefixCls},[_c('div',{staticClass:"chart-wrapper chart-wrapper-height"},[_c('v-chart',{attrs:{"force-fit":true,"height":100,"data":_vm.dataSource,"scale":_vm.scale,"padding":[36, 0, 18, 0]}},[_c('v-tooltip'),_c('v-smooth-line',{attrs:{"position":"x*y","size":2}}),_c('v-smooth-area',{attrs:{"position":"x*y"}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }